import { createContext, useContext, useEffect, useState } from 'react';
import { apiFetch } from './api.js';

// The host app bundles this file directly (relative import in App.jsx), while
// extension pages import it via the "actfact-support-portal" package specifier,
// resolved through the browser's import map to a SEPARATELY built vendor file
// (see AbstractFrontendServlet's import-map injection). Those are two different
// built files, so a plain module-level `let _bundle` here is two independent
// copies - I18nProvider only ever renders once, in the host's copy, so an
// extension's copy of this module never gets its _bundle populated and t()
// always falls back to the raw key for every extension-page call. window is
// the one thing genuinely shared across both bundles on the same page, so
// mirror the bundle there too and have t() prefer it when present.
let _bundle = {};

export function t(key) {
  const bundle = (typeof window !== 'undefined' && window.__i18nBundle) || _bundle;
  return bundle[key] ?? key;
}

const I18nContext = createContext({});

export function useT() {
  const bundle = useContext(I18nContext);
  return (key) => bundle[key] ?? key;
}

function setSharedBundle(b) {
  _bundle = b;
  if (typeof window !== 'undefined') window.__i18nBundle = b;
}

export function I18nProvider({ initialBundle = {}, locale, children }) {
  setSharedBundle(initialBundle); // sync module-level t() before children render
  const [bundle, setBundle] = useState(initialBundle);

  useEffect(() => {
    if (!locale) return;
    const controller = new AbortController();
    apiFetch(`/i18n/${locale}`, { signal: controller.signal })
      // The server's texts override the bundled ones key by key; a missing or empty server bundle
      // (e.g. the .properties not on the classpath) must not blank every label.
      .then(b => { const merged = { ...initialBundle, ...(b ?? {}) }; setSharedBundle(merged); setBundle(merged); })
      .catch(() => {});
    return () => controller.abort();
  }, [locale]);

  return <I18nContext.Provider value={bundle}>{children}</I18nContext.Provider>;
}
